import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './ActionBar';
import { getIsCurrentUserAuthorOf } from '../redux/deviations/selectors';
import { getIsBackgroundsPopupOpen } from '../DeviationBackground/redux/selectors';

export type StateProps = Pick<Props, 'isOwner' | 'isAnyDialogOpen'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (state, ownProps) => ({
  isAnyDialogOpen: getIsBackgroundsPopupOpen(state),
  isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
